import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import './global.css';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { AuthProvider } from './AuthContext.jsx';

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <React.StrictMode>
        <AuthProvider>
            <QueryClientProvider client={ queryClient }>
                <App />
                <ReactQueryDevtools initialIsOpen={ false } />
            </QueryClientProvider>
        </AuthProvider>
    </React.StrictMode>
);